import React from "react";
import { Col, Row } from "react-bootstrap";

import { CardLayout } from "../cards";
import { ActionButton, InputField } from "../v3";

export const MoveStockForm = ({
  yards,
  projects,
  items,
  item,
  details = { yard: "", project: "", date: "" },
  onChangeDetails,
  onChangeItem,
  onSubmit,
}) => {
  return (
    <Row>
      <Col>
        <CardLayout>
          <Row>
            <Col xl={4}>
              <InputField
                select={true}
                selectOptions={yards}
                label="Yard"
                name="yard"
                value={details.yard}
                onChange={onChangeDetails}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={4}>
              <InputField
                select={true}
                selectOptions={projects}
                label="Project"
                name="project"
                value={details.project}
                onChange={onChangeDetails}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={4}>
              <InputField
                type="date"
                label="Date"
                name="date"
                value={details.date}
                onChange={onChangeDetails}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={4}>
              <InputField
                select={true}
                selectOptions={items}
                label="Item"
                name="name"
                value={item.name}
                onChange={onChangeItem}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={4}>
              <InputField
                label="Quantity"
                type="number"
                name="quantity"
                value={item.quantity}
                onChange={onChangeItem}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={4}>
              <InputField
                label="Price"
                type="number"
                name="price"
                value={item.price}
                onChange={onChangeItem}
                style={{ width: "100%", marginBottom: 3 }}
              />
            </Col>

            <Col xl={12}>
              <ActionButton buttonText="Add" color="primary" onButtonClick={onSubmit} />
            </Col>
          </Row>
        </CardLayout>
      </Col>
    </Row>
  );
};
